<template>
	<div class="page">
		<div class="van-nav-bar van-nav-bar--fixed van-hairline--bottom">
			<div class="van-nav-bar__left" @click="$router.history.go(-1)">
				<Icon name="arrow-left" />
			</div>
			<div class="van-nav-bar__title van-ellipsis"> 订单列表 </div>
			<div class="van-nav-bar__right">
				<Icon name="search" size="20" style="margin-right: 15px" @click="onSearchClick"></Icon>
			</div>
		</div>

		<div class="fixed-top">
			<Tabs v-model="active" @change="onTabChange">
			  <Tab title="全部" :name=-1></Tab>
			  <Tab title="未支付" :name=0></Tab>
			  <Tab title="已支付" :name=1></Tab>
			  <Tab title="已完成" :name=1></Tab>
			</Tabs>
			<Search
				v-show="showSearch"
				v-model="value"
				show-action
				placeholder="请输入订单编号"
				@search="onSearch"
			>
			  <template #action>
			    <div @click="onSearch">搜索</div>
			  </template>
			</Search>
		</div>
		<div class="page-body" :style="listStyle">
			<PullRefresh v-model="refreshing" @refresh="onRefresh">
        <List v-model="loading" :finished="finished" finished-text="我是有底线的哦" @load="onLoad" sticky>
	        <div class="order-card" v-for="(item, index) in list" :key="index">
		        <Cell>
			        <template>
				        <p style="color: #666; font-size: 12px">订单编号：{{ item.orderNo }}</p>
			        </template>
			        <template #right-icon>
				        <span style="color: red;" v-if="item.status === 0">未支付</span>
				        <span style="color: green;" v-if="item.status === 1">已支付</span>
				        <span style="color: yellow;" v-if="item.status === 2">过期</span>
				        <span style="color: yellow;" v-if="item.status === 3">服务到期</span>
			        </template>
		        </Cell>
		        <Cell>
			        <div class="good-box" v-for="(subItem, subIndex) in item.goodList" :key="subIndex">
							  <VanImage
								  width="3rem"
								  height="3rem"
								  style="margin-right: 15px; margin-top: 5px"
								  :src="subItem.goodsImages[0].imageUrl"/>
							  <div class="right">
								  <p class="title">{{ subItem.goodsInfo && subItem.goodsInfo.goodsName }}</p>
								  <!--<p class="text"><span>监管日期：2020-09-01 至 2020-10-05</span></p>-->
								  <p class="text"><span>监管价格：{{ subItem.goodsInfo && subItem.goodsInfo.price }} /天</span></p>
								  <p class="text">x {{ subItem.orderBillDetail.goodsNum }}</p>
							  </div>
				         <p class="text" style="position: absolute; bottom: 0; right: 0">总价：￥ {{ item.price }} 元</p>
						  </div>
		        </Cell>
		        <div class="order-card-footer">
			        <Button class="item" size="small" @click="onCancelClick(item)" v-if="item.price == 0" style="margin-right: auto; color: red;">删除-取消订阅</Button>
			        <Button class="item" size="small" @click="onCancelClick(item)" v-if="item.status === 0">取消订单</Button>
			        <Button class="item" size="small" type="danger" plain @click="onBuyClick(item)" v-if="item.status === 0">继续付款</Button>
			        <!--<p class="item text">2条信息</p>-->
			        <p class="item" @click="onMoreClick(item)" v-if="item.status === 1">更多信息</p>
			        <Icon name="arrow" v-if="item.status === 1"></Icon>
		        </div>
	        </div>
        </List>
      </PullRefresh>
		</div>
	</div>
</template>

<script>
	import { NavBar, Image as VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search, Tab, Tabs } from 'vant'

  export default {
    components: { NavBar, VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search, Tab, Tabs },
    data () {
      return {
        active: -1,
        value: '',
        showSearch: false,
        list: [],
        page: 1,
        size: 100,
        error: false,
        loading: false,
        finished: false,
        refreshing: false,
	      currentTabValue: -1
      }
    },
    computed: {
      listStyle() {
        if(this.showSearch) {
          return {
            paddingTop: '140px'
          }
        } else {
          return {
            paddingTop: '90px'
          }
        }
      },
      avatar() {
        return this.$store.state.userFromJava.headImage;
      }
    },
    mounted() {
      console.log('orderList.vue init')
    },
    methods: {
      async onDeleteClick({ id }) {
        try {
          await this.$store.dispatch('deleteOrder', { id })
          this.list = this.list.filter(v => v.id !== id);
        // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      async onCancelClick(target) {
        try {
          await this.$store.dispatch('cancelOrder', { orderId: target.id })
          this.list = this.list.filter(v => v.id !== target.id);
        // eslint-disable-next-line no-empty
        } catch {}
      },
      onBackClick () {},
      onSearchClick () {
        this.showSearch = !this.showSearch
      },
      onMoreClick (target) {
        this.$router.push({
          name: 'orderDetail',
          params: {...target}
        })
      },
      onItemClick(target) {
        this.$router.push({
          name: 'goodDetail',
          query: {
            id: target.goodsInfo.id
          }
        })
      },
      onBuyClick(target) {
        this.$store.dispatch('handlePay', { orderId: target.id })
	        .then(data => {
            // this.list = this.list.filter(v => v.id !== target.id);
	        })
      },
      onSearch() {
        this.showSearch = false;
        this.refreshing = true;
        this.onRefresh({orderNo: this.value, status: this.currentTabValue});
      },
      onRefresh(param) {
        this.finished = false;
        this.loading = true;
        this.onLoad({status: this.active});
      },
      onLoad(condition) {
        if (this.refreshing) {
          this.page = 1;
          this.list = [];
          this.refreshing = false;
        }

        const targetParam = {
          page: this.page++,
          size: this.size
        };

        this.$store.dispatch('fetchOrders', {...targetParam, ...condition})
          .then(({rows, total}) => {
            this.list = [].concat(this.list, rows);
            this.loading = false;
            /*if (this.list.length >= total) {
              this.finished = true;
            }*/
            this.finished = true;
          })
          .catch(() => {
            this.loading = false;
            this.error = true
            this.finished = true;
          })
      },
      onTabChange(name, title) {
        this.currentTabValue = name;
        this.showSearch = false;
        this.refreshing = true;
        this.onRefresh({status: name});
      }
    }
  }
</script>

<style lang="less" scoped>
	.fixed-top {
		position: fixed;
		top: 46px;
		left: 0;
		right: 0;
		z-index: 2;
	}
	.page {
		height: 100%;
	}

	.van-nav-bar {
		display: flex;
		align-items: center;
		.left {
			display: flex;
			align-items: center;
		}
		.right {
			display: flex;
			align-items: center;
		}
	}

	.page-body {
		padding-top: 90px;
		padding-bottom: 50px;
		box-sizing: border-box;
		background-color: #f5f5f5;
		height: 100%;
    overflow: auto;
		/deep/.van-pull-refresh {
			min-height: 100%;
		}
	}

	.order-card {
		margin: 10px;
		border-radius: 5px;
		overflow: hidden;
		background-color: #fff;

		&-footer {
			padding: 10px 16px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 12px;

			.item {
				margin: 0 6px;
			}

			.text {
				color: #666;
			}
		}
	}

	.good-box {
		display: flex;

		.title {
			margin-bottom: 6px;
			font-size: 16px;
		}

		.text {
			line-height: 20px;
			font-size: 12px;
			color: #666;
		}

	}
</style>
